// METIS Hub wording — namespace "home" (en), 240 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/home.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const home: Record<string, string> = {
  "home.kicker.me": "My usage",
  "home.kicker.team": "My team · {team}",
  "home.kicker.all": "Company-wide",
  "home.kicker.allTeam": "Everyone · {team} only",
  "home.title.me": "My AI usage · {p}",
  "home.title.team": "{team} AI usage · {p}",
  "home.title.all": "Company-wide AI usage · {p}",
  "home.title.allTeam": "{team} AI usage · {p}",
  "home.title.ops": "Collection operations · {p}",
  "home.title.audit": "Access & change review · {p}",
  "home.desc": "{range} · Korea time · as of {asof}",
  "home.q.team": "How much and how is my team using AI?",
  "home.q.all": "How much is the company using AI, and is anything unusual?",
  "home.q.ops": "Are records coming in completely?",
  "home.q.audit": "Were all text views and permission changes recorded with a reason?",
  "home.q.stats": "When, how much and how is the company using AI?",
  "home.lead.team": "See how much and how your team uses AI.",
  "home.lead.all": "See company-wide usage and anything unusual.",
  "home.lead.ops": "First check that records are coming in completely.",
  "home.lead.audit": "Check that text views and permission changes were recorded with a reason.",
  "home.lead.stats": "See when, how much and how the company uses AI, without names.",
  "home.cli.sub": "Claude Code and Codex coding tools, whatever the payment method",
  "home.api.sub": "Calls apps and scripts made through the company gateway",
  "home.api.latA": "typical {a}",
  "home.api.latB": "slow {b}",
  "home.cli.q": "How much did I use CLI tools?",
  "home.cli.tech": "CLI tool · Claude Code · Codex",
  "home.cli.def": "Records from the AI coding tools Claude Code and Codex. They land here whatever the payment method (subscription sign-in or API key).",
  "home.cli.sum": "Questions: {s}",
  "home.cli.sumOnly": "You sent {n|question|questions}.",
  "home.m.activeClaude": "AI active time (Claude only)",
  "home.m.costCli": "Tool estimated cost",
  "home.m.calls": "Calls",
  "home.m.costApi": "Price-table cost",
  "home.m.latency": "Wait time",
  "home.cli.auth": "Payment: subscription {s} · API key {k} · unknown {u}",
  "home.cli.authNote": "By conversation · for Claude, the method last confirmed on each device",
  "home.cli.codex": "Codex",
  "home.cli.codexCost": "Codex",
  "home.cli.cache": "{p} was read from cache",
  "home.cli.noSum": "never added together",
  "home.cli.gw": "CLI (via gateway) {n|call|calls} · checking duplicates",
  "home.cli.gwHelp": "Calls the CLI tools made through the company gateway. Not added to any card until we confirm the same call isn’t counted twice.",
  "home.cli.emptyWhat": "No CLI tool records were received in this period.",
  "home.cli.noConn": "You haven’t connected a CLI tool yet.",
  "home.connect": "Connect tools",
  "home.tool.row": "{p|question|questions} · {tok}",
  "home.tool.rowApi": "{c|call|calls} · {tok}",
  "home.api.q": "How much did I call AI with API keys?",
  "home.api.tech": "API key call · company gateway",
  "home.api.def": "Calls that apps and scripts made to AI through the company gateway. Only calls through the gateway are shown per person.",
  "home.api.sum": "Calls: {s}",
  "home.api.sumOnly": "You made {n|call|calls}.",
  "home.api.latency": "typical {a} · slow {b}",
  "home.api.emptyWhat": "No API key calls through the gateway.",
  "home.api.emptyNot": "Only calls through the gateway are shown per person. It doesn’t mean API keys weren’t used.",
  "home.api.howTo": "How to connect an app",
  "home.api.org": "{k|key|keys} · {days|day|days} · usage {tok} · {usd}",
  "home.api.orgNote": "Daily · not per person · not added to the numbers above",
  "home.daily.q": "How much did I use each day?",
  "home.daily.tech": "{metric} · stacked by how used · dashed = previous period",
  "home.daily.peak": "The busiest day was {day} ({v}).",
  "home.daily.peakHour": "The busiest hour was {day} ({v}).",
  "home.daily.open": "Click to open the activity for this period",
  "home.opt.metric": "Metric",
  "home.opt.periodHelp": "Changing the period changes it for all of Home.",
  "home.models.q": "Which AI models did I use?",
  "home.models.tech": "AI model · share of {metric} · more than 5 grouped as “Other”",
  "home.models.sum": "{model} was used the most ({p}).",
  "home.models.note": "Model names as sent by the CLI tools and the gateway. The AI’s intermediate thinking is never stored.",
  "home.heat.q": "When do I use it most?",
  "home.heat.tech": "Weekday × hour · when questions were sent (Korea time)",
  "home.heat.sum": "Most questions come around {h} on {wd}.",
  "home.heat.hidden": "Hidden because fewer than 3 people remain.",
  "home.heat.unit": "questions",
  "home.recent.q": "What were my recent conversations?",
  "home.recent.tech": "Conversations · latest {n} · open one for details",
  "home.recent.all": "See all activity",
  "home.recent.sum": "The latest conversation started {rel}.",
  "home.col.when": "Time",
  "home.col.title": "Conversation",
  "home.col.tool": "Tool",
  "home.col.prompts": "Questions",
  "home.col.tokens": "Usage",
  "home.col.active": "AI active time",
  "home.col.level": "Recording level",
  "home.col.person": "Person",
  "home.conn.q": "Are my tool connections OK?",
  "home.conn.tech": "Connection status · by last received",
  "home.conn.sumOk": "All {n|connection is|connections are} sending fine.",
  "home.conn.sumSome": "Check {bad} of {n|connection|connections}.",
  "home.conn.none": "You haven’t connected any tools yet.",
  "home.conn.noneNot": "Nothing is recorded before you connect. Once connected, your next question is recorded.",
  "home.conn.last": "last received {rel}",
  "home.conn.never": "nothing received",
  "home.conn.problem": "Your {tool} connection has an error",
  "home.conn.check": "Check connection",
  "home.team.active": "Active people",
  "home.team.activeOf": "of {n} teammates",
  "home.team.costHint": "Price-table cost {b} shown separately · never added together",
  "home.team.members.q": "How much does each teammate use?",
  "home.team.members.tech": "{metric} · by name (not a ranking) · CLI solid / API hatched",
  "home.team.members.sum": "{a} of {n} teammates used AI in this period.",
  "home.team.members.former": "{n|person|people} who moved to another team are shown with their earlier records.",
  "home.team.mainTool": "Mostly {tool}",
  "home.team.noUse": "No records in this period",
  "home.team.moved": "Moved to {team} on {date} · earlier records only",
  "home.team.excluded": "Records of other managers, admins and content reviewers on the team aren’t shown ({n|person|people}).",
  "home.team.noActive": "AI active time isn’t shown per person (team totals only).",
  "home.team.ratio.q": "What share is CLI tools vs API key calls?",
  "home.team.ratio.tech": "Share by how used · CLI solid / API hatched",
  "home.team.ratio.sum": "{p} of usage is CLI tools.",
  "home.team.ratio.tokens": "Usage (tokens)",
  "home.team.ratio.count": "Questions & calls",
  "home.team.small.title": "Small-group protection is on",
  "home.team.small.body": "When fewer than 3 people remain, hourly and per-person values are hidden (your own records excepted). {team} has {n} people now.",
  "home.team.small.more": "What is small-group protection?",
  "home.team.conn.q": "Is any teammate disconnected?",
  "home.team.conn.tech": "Connection status · current teammates",
  "home.team.conn.sumNone": "All {n} teammates’ connections are fine.",
  "home.team.conn.sum": "Check connections for {bad} of {n} teammates.",
  "home.team.conn.idleNote": "No records for over 3 days shows as “Not connected”. Fine if they didn’t use it.",
  "home.org.activeUsers": "Active users",
  "home.org.ofAll": "of {n} people",
  "home.org.todayPrompts": "Questions today",
  "home.org.todayHint": "Since midnight · Korea time",
  "home.org.errors": "Errors & rejections",
  "home.org.errorsHint": "{e} failed requests · {r} rejected actions",
  "home.org.cost": "Estimated cost",
  "home.org.costHint": "CLI tool estimate · price-table cost {b} separately",
  "home.org.teams.q": "How much does each team use?",
  "home.org.teams.tech": "Usage (tokens) · by name (not a ranking) · CLI solid / API hatched",
  "home.org.teams.sum": "{u} people in {n} teams used AI.",
  "home.org.teamRow": "{n} people · {p|question|questions}",
  "home.org.smallTeams": "Small teams combined",
  "home.org.smallTeamsSub": "{t|team|teams} · {n} people (teams under 3)",
  "home.org.smallTeamsHidden": "Teams under 3 · still under 3 combined, so values are hidden",
  "home.org.members.q": "How much do people on this team use?",
  "home.org.flow.q": "How did usage change by method and tool?",
  "home.org.flow.tech": "Usage (tokens) · stacked area by tool · CLI solid / API hatched",
  "home.org.flow.sum": "{tool} is {p} of usage.",
  "home.org.anom.q": "Is anything unusual?",
  "home.org.anom.tech": "Anomalies · spikes · connections · bulk text views · collection gaps",
  "home.org.anom.sumNone": "Nothing to check right now.",
  "home.org.anom.sum": "{n|thing|things} to check.",
  "home.anom.spike": "{team} usage is {r}× the usual",
  "home.anom.spikeBody": "Today’s usage is far above the weekday average of the last two weeks. Check whether a batch was re-run.",
  "home.anom.down": "{n|connection|connections} down with an error",
  "home.anom.idle": "{n|connection|connections} with no records for over 3 days",
  "home.anom.idleBody": "Fine if they weren’t used. No record ≠ not used.",
  "home.anom.quiet": "{n|connection|connections} quiet for a while",
  "home.anom.quietBody": "No records for 4 hours to 3 days.",
  "home.anom.bulk": "{who} opened {n} texts within an hour",
  "home.anom.bulkCase": "Within investigation {id} · {from}–{to}",
  "home.anom.bulkNoCase": "Opened without an investigation. Check the reasons.",
  "home.anom.gap": "Collection gap {min} min · {from}",
  "home.anom.go.stats": "See in Insights",
  "home.anom.go.system": "Open collection status",
  "home.anom.go.audit": "Open access & change log",
  "home.org.ingest.q": "Are records coming in completely?",
  "home.org.ingest.tech": "Collection summary · last 30 days",
  "home.org.ingest.sum": "The last record arrived {rel}.",
  "home.org.received": "Received",
  "home.org.dup": "Duplicates (counted once)",
  "home.org.dropped": "Not stored by rule",
  "home.org.lastRx": "Last received",
  "home.org.conn": "Connections",
  "home.org.gap": "Collection gaps",
  "home.org.gapLine": "{n|time|times} in 7 days · longest {min} min",
  "home.org.org": "Org reports",
  "home.org.orgOk": "Anthropic sync OK",
  "home.org.orgWarn": "OpenAI: {note}",
  "home.org.system": "Open collection status",
  "home.setup.q": "Is the initial setup done?",
  "home.setup.tech": "Initial setup checklist · in install order",
  "home.setup.sum": "{n} of {total} steps done.",
  "home.setup.sumWarn": "{n} of {total} steps done; {w} need a look.",
  "home.setup.doneAt": "Done {date}",
  "home.setup.warn": "Needs a look",
  "home.setup.todo": "Not done yet",
  "home.ops.received": "Records received today",
  "home.ops.connOk": "Connected",
  "home.ops.connOkHint": "of {n} CLI connections",
  "home.ops.attention": "Connections to check",
  "home.ops.attentionHint": "error {p} · not connected {d} · quiet {q}",
  "home.ops.errorRate": "Request error rate",
  "home.ops.errorRateHint": "{e} failed / {n} requests",
  "home.ops.daily.q": "Were records received every day?",
  "home.ops.daily.tech": "Last 14 days · received · not stored by rule · duplicates",
  "home.ops.daily.sum": "{n} received today. {s}.",
  "home.ops.conn.q": "Which connections need a look?",
  "home.ops.conn.tech": "Error · not connected · quiet · by last received",
  "home.ops.conn.sum": "Start with the {p|connection|connections} that have errors.",
  "home.ops.col.user": "Person",
  "home.ops.col.device": "PC",
  "home.ops.col.tool": "Tool",
  "home.ops.col.status": "Status",
  "home.ops.col.last": "Last received",
  "home.ops.col.why": "Reason",
  "home.ops.unknown.q": "Did unknown record names arrive?",
  "home.ops.unknown.tech": "Counted by name only (not stored)",
  "home.ops.unknown.sum": "{n|unknown name|unknown names} arrived. Decide whether to add them to the support table.",
  "home.ops.noContent": "Operations can’t see question or answer text — only totals and collection status.",
  "home.aud.views": "Text views",
  "home.aud.viewsHint": "succeeded {s} · denied {d}",
  "home.aud.integrity": "Tamper check",
  "home.aud.ok": "OK",
  "home.aud.okHint": "{n} entries · anchor {date}",
  "home.aud.bad": "Broken",
  "home.aud.badHint": "Chain broken at {id}",
  "home.aud.bulk": "Bulk view alerts",
  "home.aud.bulkHint": "5 or more within an hour · last 2 days",
  "home.aud.list.q": "Who recently viewed or changed what?",
  "home.aud.list.tech": "Access & change log · latest {n} · can’t be edited or deleted",
  "home.aud.list.sum": "{d} of the latest {n} were denied.",
  "home.aud.col.when": "Time",
  "home.aud.col.kind": "What",
  "home.aud.col.actor": "Who (role)",
  "home.aud.col.target": "Target",
  "home.aud.col.cat": "Reason category",
  "home.aud.col.result": "Result",
  "home.aud.conv": "Conversation #{no}",
  "home.task.q": "Any access work to handle?",
  "home.task.tech": "Two-person approval · investigations · my access grants",
  "home.task.sum": "{n|request is|requests are} waiting for approval.",
  "home.task.sumNone": "No approval requests waiting.",
  "home.task.apr": "Request to give {who} “{perm}” ({scope})",
  "home.task.aprMeta": "{id} · requested by {req} · {date} · until {until}",
  "home.task.approve": "Approve",
  "home.task.reject": "Reject",
  "home.task.approved": "Approved. Recorded in the access & change log.",
  "home.task.rejected": "Rejected. Recorded in the access & change log.",
  "home.task.confirmTitle": "Approve this request?",
  "home.task.confirmBody": "The requester and the approver must be different people (two-person approval). Approving updates the notice wording and notifies the person.",
  "home.task.case": "Open investigation",
  "home.task.caseMeta": "{id} · {n} people · until {to} · {v} views",
  "home.task.grants": "My access grants",
  "home.task.grantsNone": "No grants open right now.",
  "home.task.grantLeft": "Conversation #{no} · {min} min left",
  "home.task.statusDone": "Handled",
};

export default home;
